"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChatModule = /** @class */ (function () {
    function ChatModule() {
    }
    return ChatModule;
}());
exports.ChatModule = ChatModule;
